/* eslint-disable quotes */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames/bind';
import { Switch } from '@beef/ui-kit';

import {
  SectionGroup,
  /* Section, */
  AddingProductRow,
  HiddenContent,
} from 'bricks';
import { formatPrice } from 'utils/formatting';
import { isScreenBelow800 } from 'store/common/settings/breakpoint/selectors';
import { getFullServices } from 'store/ProductDetails/selectors';
import { toggleService } from 'store/ProductDetails/servicesLocal/actions';

// import { Switch } from 'components';
import TabRouterLayout from '../_TabLayout';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

const yearsToMonths = {
  '1 год': '12 месяцев',
  '2 года': '24 месяца',
  '3 года': '36 месяцев',
  '4 года': '48 месяцев',
  '5 лет': '60 месяцев',
  '6 лет': '72 месяца',
  '7 лет': '84 месяца',
  '8 лет': '96 месяцев',
  '9 лет': '108 месяцев',
  '10 лет': '120 месяцев',
  '15 лет': '180 месяцев',
  '20 лет': '240 месяцев',
  '25 лет': '300 месяцев',
  '30 лет': '360 месяцев',
};

const Services = ({ services, onToggleService, isMobile }) => {
  services.sort((x, y) => {
    const nameComparison = (x.name || '').localeCompare(y.name || '');
    if (nameComparison !== 0) {
      return nameComparison;
    }
    return x.price - y.price;
  });

  return (
    <>
      {services.map(({ id, title, name, price, description, isActive, data }) => {
        const productTitle =
          data.period in yearsToMonths ?
            `${name} на ${yearsToMonths[data.period]}`
          : `${name} на ${data.period}`;

        return (
          <div className={cx('item')} key={id}>
            <Switch
              className={cx('localSwitch')}
              checked={isActive}
              onChange={onToggleService({ id: `${id}`, value: !isActive })}
              isMobile={isMobile}
              name={id}
            >
              Добавить услугу
            </Switch>
            <AddingProductRow
              subTitle={title}
              title={productTitle}
              value={`${formatPrice(price)} ₽`}
              isMobile={isMobile}
            />
            <HiddenContent label="Подробнее" content={description} />
          </div>
        );
      })}
    </>
  );
};

Services.propTypes = {
  services: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
      name: PropTypes.string,
      price: PropTypes.number,
      description: PropTypes.string,
    }),
  ),
  onToggleService: PropTypes.func,
  isMobile: PropTypes.bool,
};

const ServicesTab = () => {
  const dispatch = useDispatch();

  const { services, isMobile } = useSelector(
    (state) => ({
      services: getFullServices(state),
      isMobile: isScreenBelow800(state),
    }),
    shallowEqual,
  );

  const onToggleService = useCallback(
    (options) => () => dispatch(toggleService(options)),
    [dispatch],
  );

  return (
    <TabRouterLayout>
      <SectionGroup>
        <div className={cx('services', isMobile && 'mobile')}>
          <div className={cx('header', isMobile && 'mobile')}>Услуги</div>
          <Services services={services} onToggleService={onToggleService} isMobile={isMobile} />
        </div>
      </SectionGroup>
    </TabRouterLayout>
  );
};

export default ServicesTab;
